import React from 'react';
import { Text, Label, Crate, Logo, FlexCrate } from '@perch-labs/shrike';
import { copyFor } from 'config';
import { useAccountContext } from 'contexts/account';
import {
  PlanToggles,
  MutationVariables,
} from '../../../components/plan-toggles';
import { TogglePlan } from '../payment-method.api';

interface Props {
  plansWithThisAssignedMethod: TogglePlan[];
  plansWithOtherMethod: TogglePlan[];
  paymentMethodId: number;
  whaleAssignedPlansCount?: number;
  setMutationVariables: (variables: MutationVariables | undefined) => void;
}

const getCopy = copyFor(
  'settings.paymentInformation.paymentMethodPage.planContent'
);

export const PlanContent = (props: Props) => {
  const { selectedAccountId } = useAccountContext();
  const {
    plansWithThisAssignedMethod,
    plansWithOtherMethod,
    paymentMethodId,
    setMutationVariables,
    whaleAssignedPlansCount,
  } = props;

  const isActivePlanWhale = whaleAssignedPlansCount !== undefined; // query skipped for non-whales

  const countCopy = !plansWithOtherMethod.length
    ? getCopy('whaleAssignedPlans.all')
    : whaleAssignedPlansCount;

  const assignedPlansContent = isActivePlanWhale ? (
    <Text>
      {getCopy('whaleAssignedPlans.text', {
        whaleAssignedPlansCount: countCopy,
      })}
    </Text>
  ) : (
    <ul>
      {plansWithThisAssignedMethod.map(plan => (
        <li key={plan.id}>
          <FlexCrate margin={{ bottom: '24px' }} alignItems="center">
            <Logo type="node" variant="accent" scale={2} aria-hidden={true} />
            <Text textStyle="heading400" margin={{ left: '16px' }}>
              {plan.displayName}
            </Text>
          </FlexCrate>
        </li>
      ))}
    </ul>
  );

  return (
    <>
      {!!plansWithThisAssignedMethod.length && (
        <Crate margin={{ bottom: '32px' }} width="100%">
          <Label margin={{ bottom: '24px' }}>
            {getCopy('assignedPlansLabel')}
          </Label>
          {assignedPlansContent}
        </Crate>
      )}
      {!!plansWithOtherMethod.length && (
        <>
          <Label margin={{ bottom: '16px' }}>
            {getCopy('unassignedPlansLabel')}
          </Label>
          <PlanToggles
            accountId={selectedAccountId}
            plans={plansWithOtherMethod}
            setMutationVariables={setMutationVariables}
            isActivePlanWhale={isActivePlanWhale}
            paymentMethodId={paymentMethodId}
          />
        </>
      )}
    </>
  );
};
